import {XauditModel} from '../xaudit.model';
import {DoctorSpecialtyDataModel} from '../doctors/doctor-specialty-data.model';

export class PatientDoctorDataModel extends XauditModel {
  DoctorID: string;
  DoctorSpecId: string;
  PatientId: string;
  PracticeId: string;
  dataDoctorSpecialty: DoctorSpecialtyDataModel;
  isReferring: boolean;
}
